<div id="container"></div>
<div id="no-data">
    <div class="fof">
        <h1>Connecting to the server...</h1>
        <p>Do not hit the back or refresh button while connecting, as you may not be able to log in.</p>
    </div>
</div>